// Footer.tsx
import React from 'react';
import Grid2 from '@mui/material/Grid2/Grid2';
import { useNavigate } from 'react-router-dom';

import { Typography } from '@mui/material';
import './Footer.css';
const logoMenu = require('../assets/img/logo-menu-black.png');

interface FooterProps {
  leftComponent?: React.ReactNode;
  centerText?: string;
  rightComponent?: React.ReactNode;
}

const Footer: React.FC<FooterProps> = ({ leftComponent, centerText, rightComponent }) => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/'); // Redirige a la ruta de inicio
  };

  return (
    <footer className='footer'>
      <Grid2 container size={12} className='horizontalContainer'>
      <Grid2 size={{xs:12, md:3}}>
          <Grid2 className="logo">
            <button className="logo-button" onClick={handleHomeClick}>
              <img src={logoMenu} alt="Logo" />
            </button>
          </Grid2>
          <Grid2 className='text-group'>
            <Typography className='common-text'>®Todos los Derechos Reservados 2024</Typography>
            <Typography className='common-text'><a href="/Privacy">Aviso de Privacidad</a> | <a href="/TermsConditions">Términos y Condiciones</a></Typography>
            <Typography className='common-text'>HOY TOCA® es una marca de GRUPO HERDEZ®</Typography>
          </Grid2>
        </Grid2>

        <Grid2 size={{xs:12, md:2}}>
          <Grid2>
            <Typography className='footer-title'>Descubre</Typography>
            <Grid2 className='footer-list-container'>
              <Grid2 className='footer-item'>
                <Grid2 className='footer-indicator'></Grid2>
                <a href="/tips"><Typography className='footer-list'>Tips</Typography></a>
              </Grid2>
              <Grid2 className='footer-item'>
                <Grid2 className='footer-indicator'></Grid2>
                <a href="/Recetas"><Typography className='footer-list'>Recetas</Typography></a>
              </Grid2>
              
            </Grid2>
          </Grid2>
        </Grid2>

        <Grid2 size={{xs:12, md:2}}>
          <Grid2>
          {/* <Typography className='footer-title'>Contacto</Typography>
            <Typography className='footer-contacto'>Av. Vivente Guerrero #345
Alcaldia Miguel Hidalgo
Tel: 66-7890-8045</Typography> */}
          </Grid2>
        </Grid2>

        <Grid2 size={{xs:12, md:5}}>
          <Grid2>
            {/* <Typography className='footer-registrate'>Regístrate gratis para recibir ofertas, recetas, noticias y más.</Typography>
            <Typography className='footer-correo'>Correo electrónico</Typography>
            <Grid2 className="footer-search-box">
              <Grid2 className="footer-search-icon">
                <span className="material-icons" style={{ fontSize: '24px' }}>arrow_forward</span>
              </Grid2>
              <input 
                className="footer-search-input" 
                type="text" 
                placeholder="Ejemplo: ejemplo@correo.com" 
              />
            </Grid2> */}
          </Grid2>
        </Grid2>
      </Grid2>
    </footer>
  );
};

export default Footer;
